import React,{useState, useEffect} from 'react'
import { BiCalendar, BiFilter, BiSort } from 'react-icons/bi'
import ico from "../../../../../../assets/searchIcon/search.svg"
// import DropdownFilter from "../../../../../../../components/DropdownFilter/DropdownFilter"
import DropdownStatus from '../../../../../../../components/Dropdown/DropdownStatus'
import { END_POINT } from '../../../../../../../utils/constant'
import {formatInDate} from "../../../../../../../components/DateTimeConverter/DateTimeConverter"
import 'react-loading-skeleton/dist/skeleton.css'; 
import ImageWithFallback from '../../../../../../components/ImageWithFallback'
import { useOutletContext } from 'react-router-dom'
import { useNavigate } from 'react-router-dom'
import StatusBadge from '../../../../../../components/StatusBadge'
import InterviewScheduler from './modals/InterviewScheduler'
import ConfirmSelectionModal from './modals/ConfirmSelectionModal'
import ConfirmRecrutementModal from './modals/ConfirmRecrutementModal'
import DeclineApplicationModal from './modals/DeclineApplicationModal'
import { DropdownFilterItem, DropdownFilter } from '../../../../../../../components/Form/DropdownFilter'
import { BsFilter } from 'react-icons/bs'
import dayjs from 'dayjs'
import Dropdown from '../../../../../../../components/Dropdown/Dropdown'
import { GrUpdate } from 'react-icons/gr'

const Enrollment = ({data}) => {
    const [showModal, setShowModal] = useState(false)
    const [showSendEmailModal, setShowSendEmailModal] = useState(false)
    const {showScroll, setshowScroll} = useOutletContext()
    const [loading, setLoading] = useState(false)
    const [applicationSelected, setApplicationSelected] = useState({})
    const [option, setOption] = useState(0)
    const [showStatusModal, setShowStatusModal] = useState(false)
    const [selectedStatus, setSelectedStatus] = useState(null)
      const [openDropdown, setOpenDropdown] = useState(null);
    const navigate= useNavigate()
    const [filters, setFilters] = useState({
      keyword: "",
      status: "",
      dateRange: "",
      sort: "",
    });

    const setStatusOption = (status) => {
      console.log("action", status)
      setSelectedStatus(status) // Définir le statut sélectionné
      toggleModal(status)
      setshowScroll(false)
      // setShowStatusModal(true)
      
    };



    const handleSelect = (filterType, value) => {
      setFilters((prev) => ({ ...prev, [filterType]: value }));
    };

    const setActionOption = (status, application_id = 0) => {
      navigate("/mira-formateur/formation/inscription/"+application_id)
    }
    const [showInterviewScheduler, setShowInterviewScheduler] = useState(false);
    const [showConfirmSelectionModal, setShowConfirmSelectionModal] = useState(false);
    const [showConfirmRecrutementModal, setShowConfirmRecrutementModal] = useState(false);
    const [showDeclineApplicationModal, setShowDeclineApplicationModal] = useState(false);
  
    // Fonction pour fermer les modals
    const closeModal = (modalName) => {
      switch (modalName) {
        case "InterviewScheduler":
          setShowInterviewScheduler(false);
          break;
        case "ConfirmSelectionModal":
          setShowConfirmSelectionModal(false);
          break;
        case "ConfirmRecrutementModal":
          setShowConfirmRecrutementModal(false);
          break;
        case "DeclineApplicationModal":
          setShowDeclineApplicationModal(false);
          break;
        default:
          break;
      }
    };

    // Fonction pour ouvrir/fermer les modals
  const toggleModal = (modalName) => {
    switch (modalName) {
      case "InterviewScheduler":
        setShowInterviewScheduler((prevState) => !prevState);
        break;
      case "ConfirmSelectionModal":
        setShowConfirmSelectionModal((prevState) => !prevState);
        break;
      case "ConfirmRecrutementModal":
        setShowConfirmRecrutementModal((prevState) => !prevState);
        break;
      case "DeclineApplicationModal":
        setShowDeclineApplicationModal((prevState) => !prevState);
        break;
      default:
        break;
    }
  };

        const filteredData = data?.applications
        .filter((item) =>
          filters.keyword
            ? item.comment.toLowerCase().includes(filters.keyword.toLowerCase()) ||
              item.user.nom.toLowerCase().includes(filters.keyword.toLowerCase())
            : true
        )
        .filter((item) =>
          filters.status ? item.status === filters.status : true
        )
        .filter((item) => {
          if (!filters.dateRange) return true;
          const createdAt = dayjs(item.created_at);
      
          switch (filters.dateRange) {
            case "Aujourd'hui":
              return createdAt.isSame(dayjs(), "day");
            case "Cette semaine":
              return createdAt.isSame(dayjs(), "week");
            case "Ce mois-ci":
              return createdAt.isSame(dayjs(), "month");
            default:
              return true;
          }
        })
        .sort((a, b) => {
          if (filters.sort === "Ordre croissant" || filters.sort === "Date ancien") {
            return dayjs(a.created_at).isAfter(dayjs(b.created_at)) ? 1 : -1;
          } else if (
            filters.sort === "Ordre décroissant" ||
            filters.sort === "Date récent"
          ) {
            return dayjs(a.created_at).isBefore(dayjs(b.created_at)) ? 1 : -1;
          } else if (filters.sort === "Alphabétique") {
            return a.user.nom.localeCompare(b.user.nom);
          }
          return 0;
        });

        const toggleDropdown = (menu) => {
          setOpenDropdown(openDropdown === menu ? null : menu);
        };

  return (
    <div className=''>
        <div className=" flex justify-between items-center mb-4">
          <h4 className='font-semibold whitespace-nowrap'>Historique des candidatures</h4>
          <div className="flex flex-wrap gap-2 justify-end w-full">
    {/* Barre de recherche */}
    <div className="relative flex items-center w-60 h-10 rounded-lg overflow-hidden border">
      <div className="grid place-items-center h-full w-12 text-gray-300">
        <img src={ico} alt="bouton de recherche" />
      </div>
      <input
        className="peer h-full w-full outline-none text-sm text-gray-700 pr-2"
        type="text"
        id="search"
        placeholder="Rechercher un mot-clé..."
        onChange={(e) => handleSelect("keyword", e.target.value)}
      />
    </div>

    <DropdownFilter
        label={filters.dateRange || "Date"}
        icon={<BiCalendar />}
        isOpen={openDropdown === "dateRange"}
        onToggle={() => toggleDropdown("dateRange")}
      >
        <DropdownFilterItem
          text="Aujourd'hui"
          onClick={() => handleSelect("dateRange", "Aujourd'hui")}
        />
        <DropdownFilterItem
          text="Cette semaine"
          onClick={() => handleSelect("dateRange", "Cette semaine")}
        />
        <DropdownFilterItem
          text="Ce mois-ci"
          onClick={() => handleSelect("dateRange", "Ce mois-ci")}
        />
      </DropdownFilter>

      {/* Filtre par état */}
      <DropdownFilter
        label={filters.status || "État"}
        icon={<BsFilter />}
        isOpen={openDropdown === "status"}
        onToggle={() => toggleDropdown("status")}
      >
        <DropdownFilterItem
          text="En attente"
          onClick={() => handleSelect("status", "En attente")}
        />
                <DropdownFilterItem
          text="Accepté"
          onClick={() => handleSelect("status", "Accepté")}
        />
        <DropdownFilterItem
          text="Refusé"
          onClick={() => handleSelect("status", "Refusé")}
        />
      </DropdownFilter>

      <DropdownFilter
        label={filters.sort || "Tri"}
        icon={<BiSort />}
        isOpen={openDropdown === "sort"}
        onToggle={() => toggleDropdown("sort")}
      >
        <DropdownFilterItem
          text="Ordre croissant"
          onClick={() => handleSelect("sort", "Ordre croissant")}
        />
        <DropdownFilterItem
          text="Ordre décroissant"
          onClick={() => handleSelect("sort", "Ordre décroissant")}
        />
        <DropdownFilterItem
          text="Date ancien"
          onClick={() => handleSelect("sort", "Date ancien")}
        />
        <DropdownFilterItem
          text="Date récent"
          onClick={() => handleSelect("sort", "Date récent")}
        />
      </DropdownFilter>

      <button
      onClick={()=>setFilters({...filters,   keyword: "", status: "", dateRange: "", sort: "",})}
      className="flex items-center space-x-2 px-4 py-2 border rounded-lg bg-white shadow-sm hover:bg-gray-100"
    >
     <GrUpdate/>
    </button>
  </div>
        </div>


      <div className="w-full pb-28 lg:w-[100%] xl:w-[900px] min-[1300px]:w-full overflow-x-auto">
        <table className="  text-sm whitespace-pre w-full ">
          <thead>
            <tr className="text-left text-sm bg-neutral-100  rounded-sm">
              <th className="pl-5 bg-neutral-100 py-2 rounded-sm">Candidat</th>
              {/* <th className="pl-5 bg-neutral-100 py-2 rounded-sm">Evaluation</th> */}
              <th className="pl-5 bg-neutral-100 py-2 rounded-sm">Etat</th>
              <th className="pl-5 bg-neutral-100 py-2 rounded-sm">Date d'inscription</th>
              <th className="pl-5 bg-neutral-100 py-2 rounded-sm ">Action</th>
            </tr>
          </thead>
          <tbody>
           
            {filteredData?.map((application, index) => (
              <tr key={application.id} className=" border-b border-gray-100 rounded ">
                <td className=" py-3">
                  <div className="flex  ml-5 items-center gap-2 text-start ">
                    <input type="checkbox" name="g" id="" className='w-4 h-4 rounded-lg' />
                     <div className="flex items-center gap-1 p-1.5 w-fit hover:bg-neutral-100 rounded-lg cursor-pointer">
                        <ImageWithFallback src={END_POINT+"/storage"+application?.user?.photo} alt="user1" defaultType='user' className='w-8 h-8 rounded-full' /> 
                        <div className="flex flex-col justify-between  w-fit mr-5 px-4">
                          <p className="text-base font-medium mr-2">{application?.user?.nom}</p>
                          <div className="flex gap-2 text-xs">
                          {application?.user?.email}
                          </div>
                      </div>
                     </div>
                  </div>
                </td>
                <td className="pl-5  justify-start ">                
                      <StatusBadge status={application?.status} />
                </td>
                <td className="pl-5">
                  <p className="text-sm leading-none  text-start flex gap-1 items-center text-primary-text">
                  {formatInDate(application?.created_at)}</p>
                </td>
                <td className="pl-5">
                    <div className="flex  items-center gap-2 text-start ">
                    <DropdownStatus application={application} setApplicationSelected={(val)=>setApplicationSelected(val)}  setDisplayModal={setStatusOption} key={index} />
                    <Dropdown showModal={showModal} setShowModal={setActionOption} item={application} offer= {data}/>
                    </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <InterviewScheduler applicationId={applicationSelected?.id} show={showInterviewScheduler} onClose={() => toggleModal("InterviewScheduler")} />
      <ConfirmSelectionModal applicationId={applicationSelected?.id} show={showConfirmSelectionModal} onClose={() => toggleModal("ConfirmSelectionModal")} />
      <ConfirmRecrutementModal applicationId={applicationSelected?.id} show={showConfirmRecrutementModal} onClose={() => toggleModal("ConfirmRecrutementModal")} />
      <DeclineApplicationModal applicationId={applicationSelected?.id} show={showDeclineApplicationModal} onClose={() => toggleModal("DeclineApplicationModal")} />
{/* 
      <InterviewScheduler show={showInterviewScheduler} onClose={() => closeModal("InterviewScheduler")} />
      <ConfirmSelectionModal show={showConfirmSelectionModal} onClose={() => closeModal("ConfirmSelectionModal")} />
      <ConfirmRecrutementModal show={showConfirmRecrutementModal} onClose={() => closeModal("ConfirmRecrutementModal")} />
      <DeclineApplicationModal show={showDeclineApplicationModal} onClose={() => closeModal("DeclineApplicationModal")} /> */}

      {/* <AnimatePresence>
    {
        showStatusModal && (
    
        <motion.div 
        initial={{ opacity: 0  }}
        animate={{opacity: 1}}
        exit={{ opacity: 0 }}
        className="fixed ease-in duration-200 z-40 bg-gray-900/10 top-0 bottom-0 left-0 right-0 flex justify-end backdrop-blur-sm backdrop-filter">
        <motion.div
        initial={{ opacity: 0, right: "-100%", y: 20 }}
        animate={{ opacity: 1, right: 0, y: 0 }}
        exit={{ opacity: 0, right: "-100%", y: 20 }}
        transition={{ type: "spring", stiffness: 130, damping: 20 }}
        className="fixed  overflow-y-auto bg-white w-full lg:w-2/3 xl:w-1/2 min-h-full lg:rounded-s-2xl drop-shadow-lg max-h-screen space-y-4"
        >
           
             {renderModalContent()}
            

            </motion.div>
        </motion.div>
        )}
        </AnimatePresence>   */}



    </div>
  )
}

export default Enrollment    
  // const renderModalContent = () => {
      //   switch (selectedStatus) {
      //     case 1:
      //       return (
      //         <div>
      //            <div className="flex justify-between  py-4 border-b px-6 ">
      //             <h4 className="text-lg font-bold"> Confirmer la sélection de la candidature</h4>
      //             <button 
      //             onClick={()=>{
      //                 setShowStatusModal(false)
      //                 setshowScroll(true)
      //                 }}>
      //                 <CgClose/>
      //             </button>
      //             </div>
      //             <div className='px-6 space-y-2 flex-col items-start mt-4'>   
      //           <p>Êtes-vous sûr de vouloir sélectionner ce candidat ?</p>
      //           <div className="flex justify-end space-x-4">
      //             <button
      //               onClick={() => setShowStatusModal(false)}
      //               className="text-primary-black bg-slate-50 rounded-md px-4 py-2 shadow-sm hover:bg-slate-100"
      //             >
      //               Annuler
      //             </button>
      //             <button
      //               className="text-white bg-green-500 rounded-md px-4 py-2 shadow-sm hover:opacity-80"
      //             >
      //               Confirmer
      //             </button>
      //           </div>
      //           </div>
      //           </div>
      //       );
      //     case 2:
      //       return (
      //         <div>
      //           <div className="flex justify-between  py-4 border-b px-6 ">
      //             <h4 className="text-lg font-bold">Planifier un entretien </h4>
      //             <button 
      //             onClick={()=>{
      //                 setShowStatusModal(false)
      //                 setshowScroll(true)
      //                 }}>
      //                 <CgClose/>
      //             </button>
      //             </div>
      //             <div className='px-6 space-y-2 flex-col items-start mt-4'> 
      //                 <p className=' text-start bg-p-400'>Date :</p>
                      
                        
      //                     <input type="date" className="border rounded-md p-2 w-full" />
                       
      //                   <p>Heure :</p>
      //                     <input
      //                       type="time"
      //                       className="border rounded-md p-2 w-full"
      //                     />
      //                   <p>Message :</p>
      //                   <textarea name="" id="" className='h-96 border rounded-md w-full p-2 bg-gray-50 focus:outline-none'>

      //                   </textarea>
                        
      //                   <div className="flex justify-end space-x-4">
      //                     <button
      //                       onClick={() => setShowStatusModal(false)}
      //                       className="text-primary-black bg-slate-50 rounded-md px-4 py-2 shadow-sm hover:bg-slate-100"
      //                     >
      //                       Annuler
      //                     </button>
      //                     <button
      //                       className="text-white bg-blue-500 rounded-md px-4 py-2 shadow-sm hover:opacity-80"
      //                     >
      //                       Programmer et envoyer
      //                     </button>
      //                   </div>
      //               </div>
      //         </div>
      //       );
      //     case 4:
      //       return (
      //         <div>
      //            <div className="flex justify-between  py-4 border-b px-6 ">
      //             <h4 className="text-lg font-bold">Décliner la candidature</h4>
      //             <button 
      //             onClick={()=>{
      //                 setShowStatusModal(false)
      //                 setshowScroll(true)
      //                 }}>
      //                 <CgClose/>
      //             </button>
      //             </div>
      //           <div className='px-6 space-y-2 flex-col items-start mt-4'> 
      //           <Select options={["Sélectionner un motif de réfus"]} />
      //           <textarea
      //             className="h-[500px] border rounded-md w-full p-2 bg-gray-50 focus:outline-none"
      //             placeholder="Message pour le candidat..."
      //           />
      //           <div className="flex justify-end space-x-4">
      //             <button
      //               onClick={() => setShowStatusModal(false)}
      //               className="text-primary-black bg-slate-50 rounded-md px-4 py-2 shadow-sm hover:bg-slate-100"
      //             >
      //               Annuler
      //             </button>
      //             <button
      //               className="text-white bg-red-500 rounded-md px-4 py-2 shadow-sm hover:opacity-80"
      //             >
      //               Décliner et envoyer
      //             </button>
      //           </div>
      //           </div>
      //         </div>
      //       );
      //     case 3:
      //       return (
      //         <div>
      //             <div className="flex justify-between  py-4 border-b px-6 ">
      //             <h4 className="text-lg font-bold">Confirmer le recrutement </h4>
      //             <button 
      //             onClick={()=>{
      //                 setShowStatusModal(false)
      //                 setshowScroll(true)
      //                 }}>
      //                 <CgClose/>
      //             </button>
      //             </div>
      //           {/* <h4 className="text-lg font-bold">Confirmer le recrutement</h4> */}
      //           <div className="p-4">
      //           <textarea
      //             className="h-96  border rounded-md w-full p-2 bg-gray-50 focus:outline-none"
      //             placeholder="Message pour le candidat..."
      //           />
      //           <div className="flex justify-end space-x-4 mt-3">
      //             <button
      //               onClick={() => setShowStatusModal(false)}
      //               className="text-primary-black bg-slate-50 rounded-md px-4 py-2 shadow-sm hover:bg-slate-100"
      //             >
      //               Annuler
      //             </button>
      //             <button
      //               className="text-white bg-green-600 rounded-md px-4 py-2 shadow-sm hover:opacity-80"
      //             >
      //               Récruter maintenant
      //             </button>
      //           </div>
      //           </div>
      //         </div>
      //       );
      //     default:
      //       return null;
      //   }
      // };
